import './FloatingIcon.css'

export default function FloatingIcon() {
  return (
    <div className="floating-icon-wrapper">
      <a
        href="https://provence-compta.com"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-icon action"
        aria-label="Accéder à Provence Compta"
      >
        <img src={`${process.env.PUBLIC_URL}/images/provencecompta_logoS.png`} alt="Logo Provence Compta" />
      </a>
    </div>
  )
}
